export const getDurationSettingKey = (appointmentType) => `${appointmentType}Duration`;
